import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
        {description && <p className="mt-2 text-sm text-slate-600 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, icon: Icon, dark, testid }) {
  return (
    <div className={`rounded-lg border p-5 ${dark ? "bg-slate-900 border-slate-900 text-white" : "bg-white border-slate-200"}`} data-testid={testid}>
      <div className="flex items-center justify-between">
        <p className={`text-xs font-semibold uppercase tracking-wider ${dark ? "text-slate-400" : "text-slate-500"}`}>{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${dark ? "text-amber-400" : "text-amber-500"}`} />}
      </div>
      <p className="font-display text-3xl font-extrabold mt-3">{value}</p>
      {hint && <p className={`text-xs mt-1 ${dark ? "text-slate-400" : "text-slate-500"}`}>{hint}</p>}
    </div>
  );
}

export function EmptyState({ text, testid = "empty-state" }) {
  return <div className="rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500" data-testid={testid}>{text}</div>;
}

export function InactiveNotice() {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-6 flex flex-wrap items-center justify-between gap-4" data-testid="inactive-package-notice">
      <div className="flex gap-3">
        <Lock className="h-5 w-5 text-amber-600 mt-0.5" />
        <div>
          <p className="font-semibold text-slate-900">Paket belum aktif</p>
          <p className="text-sm text-slate-600">Selesaikan pembayaran atau perpanjang paket untuk membuka materi, kelas, dan ujian.</p>
        </div>
      </div>
      <Button asChild className="bg-slate-900" data-testid="inactive-go-payment-button"><Link to="/siswa/profil">Lihat Paket & Pembayaran</Link></Button>
    </div>
  );
}
